// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"327d451e","453":"cca7128c","457":"bc01f9f6","551":"f82ecf17","640":"b354ee60","851":"21df6352"}[chunkId] + ".chunk.js";
};